import { get } from 'lodash';
import axios from 'axios';
import { NETWORK } from '../../../framework/App/AppConstants';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { APP_PEND_FINAL_SUBMIT_CALL_API } from '../../config/apiEndpoints';
import { safeStringifyAxios } from '../../../shared-utilities/safeStringify';
import { sessionTimeoutHandler } from './utils/sessionTimeoutHandler';

export const submitDocumentsApi = () => (dispatch, getState) => {
    const logPrefix = 'appPendFinalSubmit:';
    const { serverData = {} } = getState();
    const { _csrf = '', appPendData = {}, flow = '' } = serverData;
    return axios
        .request({
            url: APP_PEND_FINAL_SUBMIT_CALL_API,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            }
        })
        .then((response) => {
            dispatch(setServerData({
                appPendData: {
                    ...appPendData,
                    finalUvsResponse: get(response, 'data', {})
                }
            }));
            capeLog && capeLog(`${logPrefix} response: ${safeStringifyAxios(response)}`);
        })
        .catch(error => {
            capeLog && capeLog('response:error, submitDocumentsApi,' + (error && error.message));
            sessionTimeoutHandler(error, dispatch, flow);
        });
};
